import React from 'react';
import PropTypes from 'prop-types';
import List from './List/List';
import { getOriginalImage, clientTitle } from '../utils/prismic';
import { isOdd } from '../utils/functions';
const linkResolver = require('../../config/linkResolver');

const ListCaseStudies = ({ input }) => {
  let caseStudies =
    input &&
    input.map((x, index) => {
      const alignThumb = !isOdd(index)
        ? x.data.internal_thumb_textleft || x.data.internal_thumb_textright
        : x.data.internal_thumb_textright || x.data.internal_thumb_textleft;

      return {
        key: x.id.toString(),
        type: 'flexible',
        dest: linkResolver(x),
        theme_light: x.data.client_colour,
        theme_dark: x.data.client_accent,
        thumbnail: {
          url: getOriginalImage(alignThumb).url,
          alt: getOriginalImage(alignThumb).alt || clientTitle(x.data),
        },
        title: x.data.client_alias,
        description: x.data.summary.text,
        buttonText: 'View Project',
      };
    });

  return (
    <List
      className="case-study-list"
      itemWidth={100}
      itemHeight={25}
      isFullWidth
      cards={caseStudies}
    />
  );
};

ListCaseStudies.propTypes = {
  input: PropTypes.array.isRequired,
};

export default ListCaseStudies;
